import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BaseModalComponent, LoadingService, Membership, MembershipService, Organization, Person} from 'brewbill-lib';
import {ModalController} from '@ionic/angular';
import moment from 'moment/moment';

@Component({
    selector: 'bb-create-unpaid-membership',
    templateUrl: './create-unpaid-membership.component.html',
    styleUrls: ['./create-unpaid-membership.component.scss'],
})
export class CreateUnpaidMembershipComponent extends BaseModalComponent implements OnInit {
    @Input() organization: Organization;

    personFormGroup: FormGroup = new FormGroup({});
    formGroup: FormGroup;
    endMax: string;

    constructor(
        private membershipService: MembershipService,
        private loadingService: LoadingService,
        private formBuilder: FormBuilder,
        modalController: ModalController
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            parentId: this.organization.id,
            membershipProgramId: ['', Validators.required],
            initialTokenCount: ['', [Validators.required, Validators.min(0)]],
            memberNumber: '',
            startDate: ['', Validators.required],
            endDate: ['', Validators.required]
        });

        const now = moment();
        now.add(20, 'years');
        this.endMax = now.format();
    }

    personFormInitialized(form: FormGroup) {
        this.personFormGroup = form;
    }

    setProgram() {
        const id = this.formGroup.controls.membershipProgramId.value;
        if (!!id) {
            const program = this.organization.membershipPrograms.find(p => p.id === id);
            this.formGroup.controls.initialTokenCount.setValue(program.tokens);
        }
    }

    setValue(field, val) {
        this.formGroup.get(field).setValue(val);
    }

    onSubmit() {
        const member = new Membership(this.formGroup.value);
        member.person = new Person(this.personFormGroup.value);
        this.loadingService.present();
        this.membershipService.createUnpaid(member).subscribe(m => {
            this.loadingService.dismiss();
            this.close(new Membership(m));
        });
    }
}
